var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg181(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 24C41.5082 27.9101 40.1992 31.709 37.784 34.784L35 32L33 34V43H42L44 41L41.34 38.34C44.6832 34.31 46.5089 29.2362 46.5 24C46.5 11.574 36.426 1.5 24 1.5C11.574 1.5 1.5 11.574 1.5 24C1.5 36.426 11.574 46.5 24 46.5C25.54 46.4973 27.0393 46.3473 28.498 46.05L27.502 41.15C23.9638 41.8727 20.2886 41.483 16.9805 40.0345C13.6725 38.586 10.8936 36.1495 9.02496 33.0593C7.15632 29.969 6.28946 26.3764 6.54328 22.774C6.7971 19.1716 8.15916 15.736 10.4427 12.9383C12.7262 10.1407 15.8192 8.11793 19.2977 7.14757C22.7762 6.17721 26.4697 6.30675 29.8716 7.51842C33.2736 8.73008 36.2174 10.9645 38.2993 13.9153C40.3812 16.8661 41.4992 20.3887 41.5 24ZM26 13V25L25.2 25.6L17.2 31.6L14.8 28.4L22 23V13H26Z",
    fill: "#DB2A12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg181);
export default __webpack_public_path__ + "static/media/svg181.cc0baecc5dfb450a67dfb512d0ba16c5.svg";
export { ForwardRef as ReactComponent };